module.exports = __webpack_public_path__ + "static/media/bank-transfer.7da54784.png";